import { useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/store.config';
import { IResponse } from '@/models/entities/IResponse';

interface UploadOptions {
    url: string;
    fieldName?: string; // 對應後端接收檔案欄位名，預設為 "file"
    onSuccess?: (response: IResponse<null>) => void;
    onError?: (error: unknown) => void;
}

export function useFileUpload() {
    const [progress, setProgress] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<unknown>(null);
    const token = useSelector((state: RootState) => state.userStore.token);
    const apiConfig = useSelector((state: RootState) => state.configStore.apiHost);

    const upload = async (file: File, options: UploadOptions) => {
        const { url, fieldName = 'file', onSuccess, onError } = options;
        const formData = new FormData();
        formData.append(fieldName, file);

        setLoading(true);
        setError(null);
        setProgress(0);

        try {
            const res = await axios.post(`${apiConfig?.host || ''}${url}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    token: token,
                },
                onUploadProgress: (event) => {
                    if (event.total) {
                        const percent = Math.round((event.loaded * 100) / event.total);
                        setProgress(percent);
                    }
                },
            });

            setLoading(false);
            setProgress(100);
            onSuccess?.(res.data);
        } catch (err) {
            setLoading(false);
            setError(err);
            setProgress(0);
            onError?.(err);
        }
    };

    return {
        upload,
        progress,
        loading,
        error,
    };
}
